// extracted by mini-css-extract-plugin
export var aircallIframe = "_n7-3";
export var fabContainer = "_n7-5";
export var fabRinging = "_n7-6";
export var loadingOverlay = "_n7-4";
export var pulse = "_n7-7";
export var widgetContent = "_n7-2";
export var widgetPanel = "_n7-0";
export var widgetPanelExpanded = "_n7-1";